import Header from "../comm/Header";
import Paging from "../comm/Paging";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { reqData } from "../../js/server";
// import { fnNotLogin } from "../../js/util";

function InfoList() {
  const dispatch = useDispatch();
  const postsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [posts, setPosts] = useState([]);
  const [keyword, setKeyword] = useState("");

  const setPage = (page) => {
    fetchData(page);
  };

  async function fetchData(page = 1) {
    setCurrentPage(Number(page));

    const jsonData = {
      servicename: "NEWS",
      keyword: keyword,
      currentPage: page,
      maxListCount: postsPerPage,
    };

    dispatch({ type: "loadingChange", payload: true });
    reqData(jsonData)
      .then((res) => {
        if (res.data.result === "OK") {
          setTotalCount(res.data.totalCnt);
          setPosts(res.data.jsonData);
        } else {
          console.error(res.data.msg);
          setTotalCount(0);
          setPosts([]);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setTimeout(() => {
          dispatch({ type: "loadingChange", payload: false });
        }, 500);
      });
  }

  useEffect(
    () => {
      // if (localStorage.getItem('comcode')) {
      fetchData(1);
      // } else {
      //     alert('인트라밴 솔루션 고객만 접근이 가능한 메뉴입니다.')
      //     fnNotLogin()
      // }
    },
    // eslint-disable-next-line
    []
  );

  return (
    <>
      <section className="section cscenter">
        <Header page="sub" />

        <div className="container mt-7">
          <div className="row">
            <div className="col-12">
              <h2 className="text-white">업계이슈</h2>
              <p className="text-white pt-3">고객센터 &gt; 업계이슈</p>
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="row pt-99">
          <div className="col-12">
            <h2>자동차 업계 이슈를 알려드립니다.</h2>

            <p className="pt-3">
              정비업 이슈 혹은 IT 관련 동향 등 인트라밴에서 운영하는 하이웨이
              블로그와 카페에서 알려 드립니다.
            </p>
          </div>
        </div>

        <div className="row pt-5">
          <div className="col-12 text-center">
            <div className="search-bar">
              <div className="input-group">
                <input
                  className="form-control transparent-input"
                  type="text"
                  name="keyword"
                  placeholder="제목으로 검색이 가능합니다."
                  maxLength="20"
                  value={keyword || ""}
                  onChange={(e) => setKeyword(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      fetchData(1);
                    }
                  }}
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-link"
                    type="button"
                    onClick={() => fetchData(1)}
                  >
                    <i className="fas fa-search" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row pt-5">
          <div className="col-12 accd-wrap">
            <table className="table table-hover">
              <tbody>
                {posts.length > 0 ? (
                  posts.map((post, i) => {
                    return (
                      <tr
                        key={i}
                        className="info-table-row"
                        onClick={() => {
                          window.open(post.link, "_blank");
                        }}
                      >
                        <td className="p-4">
                          {post.title || ""}
                          {post.link.indexOf("blog") > -1 ? (
                            <img
                              src="../assets/iconBlog.png"
                              alt="blog"
                              className="naverIcon"
                            />
                          ) : (
                            <img
                              src="../assets/iconCafe.png"
                              alt="cafe"
                              className="naverIcon"
                            />
                          )}
                        </td>
                        <td className="p-4 text-right">
                          {post.wdate ? post.wdate.substring(0, 10) : ""}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td className="p-4">결과가 없습니다.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="row pt-3 pb-99">
          <div className="col-12">
            <Paging page={currentPage} count={totalCount} setPage={setPage} />
          </div>
        </div>
      </div>
    </>
  );
}

export default InfoList;
